<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" >
      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Device</label>
          <v-select :options="deviceList" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filter.device" @search="searchDevice" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="vs-input--label">Date</label>
          <flat-pickr :config="{ dateFormat: 'Y-m-d' }" style="width: 100%" v-model="filter.date"/>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <vs-button :disabled="loading" id="searchBtn" style="width: 100%" color="success" type="filled" icon-pack="feather" icon="icon-search" class="pl-5 mt-1 vs-con-loading__container" @click="search">Search</vs-button>
        </div>
      </div>
    </vx-card>

        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <vx-card title="Line Chart">
                    <vue-apex-charts type="line" height="350" :options="lineChartSimple.chartOptions" :series="lineChartSimple.series"></vue-apex-charts>
                    <template slot="codeContainer">
                    </template>
                    <vs-pagination :total="n_page" v-model="page"></vs-pagination>
                </vx-card>
            </div>
        </div>
  </div>

</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select'
import FileDownload from 'js-file-download'

import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    flatPickr,
    vSelect,
    VueApexCharts
  },

  data () {
    return {
      lineChartSimple: {
        series: [],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            },
            // toolbar: {
            //   show: false
            // },
          },
          colors: ['#479DD7'],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: 'Fuel(L)',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            type: 'category',
            categories: []
          },
          noData: {
            text: 'No Data'
          },
        }
      },

      // data: [],
      token: '',
      action: '',
      loading: false,
      actor: '',
      tempId: 0,

      filter: {
        device: '',
        date: null
      },

      filtered: {
        device: '',
        date: null
      },

      deviceList: [],
      page: 1,
      per_page: 20,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total/this.per_page)
    },
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if(this.page != 1) this.page = 1
      else this.initTable()
    },
  },

  created () {
    this.token = localStorage.getItem('userInfo') !== null ? JSON.parse(localStorage.getItem('userInfo')).token : ''

    this.$http.get(`${this.$api.endpoint}/user/profile`, {
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    }).then(res => {
      this.actor = res.data.message.data
    }).catch(error => {
      this.$gf.httpErrorHandler(error)
    })
  },

  mounted () {
  },

  methods: {
    updatePerPage(n) {
      this.per_page = n
    },

    searchDevice(keyword) {
      if(keyword.length >= 3) {
        this.$http.get(`${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        }).then(res => {
          this.deviceList = res.data.message.data
        }).catch(error => {
          this.$gf.httpErrorHandler(error)
        })
      }else{
        this.deviceList = []
      }
    },

    initTable() {
      this.loading = true
      this.lineChartSimple.chartOptions = {...this.lineChartSimple.chartOptions, ...{
        noData: {
          text: "Loading...."
        },
        xaxis: {
          categories: []
        }
      }}

      this.lineChartSimple.series = []

      this.$http.get(`${this.$api.endpoint}/report/fuel_chart`, {
        params: {
          page: this.page,
          per_page: this.per_page,
          device: this.filter.device ? this.filter.device.value : '',
          date: `${this.filter.date}`,
        },

        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.loading = false
        this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

        this.row_total = res.data.message.total

        var data = res.data.message.data

        this.lineChartSimple.chartOptions = {...this.lineChartSimple.chartOptions, ...{
          xaxis: {
              categories: data.category.time
          }
        }}

        this.lineChartSimple.series = [
          {
            name: 'Fuel(km/h)',
            data: data.series.fuel
          }
        ]

        if(data.category === ''){
          this.lineChartSimple.chartOptions = {...this.lineChartSimple.chartOptions, ...{
            noData: {
              text: "No Data"
            },
            xaxis: {
              categories: []
            }
          }}
        }
        // console.log(data)

      }).catch(error => {
        this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
        this.$gf.httpErrorHandler(error)
      })
    },

    search() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: "#searchBtn",
        scale: 0.45
      })

      this.filtered.device = this.filter.device
      this.filtered.date = this.filter.date

      this.page = 1
      this.initTable()

    },
  },

}

</script>
